"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviantArtIcon = void 0;

var _element = require("@wordpress/element");

var _primitives = require("@wordpress/primitives");

/**
 * WordPress dependencies
 */
const DeviantArtIcon = () => (0, _element.createElement)(_primitives.SVG, {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  version: "1.1"
}, (0, _element.createElement)(_primitives.Path, {
  d: "M 18.19 5.636 18.19 2 18.188 2 14.553 2 14.19 2.366 12.474 5.636 11.935 6 5.81 6 5.81 10.994 9.177 10.994 9.477 11.357 5.81 18.363 5.81 22 5.811 22 9.447 22 9.81 21.634 11.526 18.364 12.065 18 18.19 18 18.19 13.006 14.823 13.006 14.523 12.641 18.19 5.636z"
}));

exports.DeviantArtIcon = DeviantArtIcon;
//# sourceMappingURL=deviantart.js.map